// What a screen share may show. The browser's own hints (no whole screen, not this tab) are honoured only by Chrome, so
// after the picker the choice is read back and refused when it could show what the customer must not see (audit F14):
// on the navigator a single browser tab only — a window or the screen could hold the brief and live assist; on Canvas's
// plain call a tab or a window, never the whole screen. ClikMeet (Ravi, 25 Sep) is colleagues sharing their own desk:
// any of the three, whole screen included, and the sound with it, so a video played on the screen is heard by everyone.
export const SHARE_TAB = ["browser"];
export const SHARE_TAB_OR_WINDOW = ["browser", "window"];
export const SHARE_ANY = ["browser", "window", "monitor"];

// surface: what the browser says was picked ("browser" | "window" | "monitor" | undefined when it does not say).
export function shareAllowed(surface, allow) {
  return Boolean(surface) && allow.includes(surface);
}

// Answers { video, audio }: audio is the shared sound when it was asked for and the person kept the browser's "share
// audio" box ticked, otherwise null. Which sound a browser can give is its own: Chrome and Edge give a tab's sound
// everywhere and the whole screen's on Windows and ChromeOS; Safari and Firefox give none.
export async function pickShare(allow, { audio = false } = {}) {
  const screen = allow.includes("monitor");
  const stream = await navigator.mediaDevices.getDisplayMedia({
    video: { frameRate: { ideal: 15, max: 30 }, displaySurface: screen ? "monitor" : allow.length === 1 ? "browser" : "window" },
    audio: audio ? { echoCancellation: false, noiseSuppression: false, autoGainControl: false } : false,
    ...(audio ? { systemAudio: "include" } : {}),
    monitorTypeSurfaces: screen ? "include" : "exclude", selfBrowserSurface: "exclude", surfaceSwitching: "include", preferCurrentTab: false,
  });
  const mst = stream.getVideoTracks()[0];
  const surface = mst.getSettings?.().displaySurface;
  if (!shareAllowed(surface, allow)) {
    stream.getTracks().forEach((t) => t.stop());
    const err = new Error(allow.length === 1
      ? (surface ? "Share one browser tab — a window or the whole screen could show your private panel to them." : "Sharing a single tab needs Chrome or Edge — the canvas itself needs no share.")
      : "Share a window or a tab — not the whole screen.");
    err.refused = true;
    throw err;
  }
  return { video: mst, audio: (audio && stream.getAudioTracks()[0]) || null };
}
